import * as React from "react";
import {translate} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import {Col, Container, Row} from "reactstrap";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {formatDateForBottomBar, getWeekdayFromDate} from "../../DateHelper";
import Subtitle from "../../components/Subtitle";
import TextField from '@material-ui/core/TextField';
import {ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Radio from '@material-ui/core/Radio';
import {SpacerRow} from "../../components/SpacerRow";
import SubPageTopBar from "../../components/SubPageTopBar";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import vodafoneLogo from "../../media/icons/vf-logo.png";

const BUILDING_TYPES = {
    EFH: "EFH",
    MFH: "MFH"
};

/**
 * Stage 4 - Check Information (DSL)
 */
class Stage4CheckInformation extends React.Component {

    /**
     * constructor
     * @param props
     */
    constructor(props){

        super(props);

        this.isValidForm = -1;

        this.state = {
            previousTenant: props.previousTenant ? props.previousTenant : {},
            benachrichtigungPer: props.benachrichtigungPer ? props.benachrichtigungPer : false,
            address: props.address ? props.address : {},
            contactInformation: props.contactInformation ? props.contactInformation : {},
            building: props.building ? props.building : {},
            mainButtonSettings:{
                mainButtonOnClick:() => {return true},
                mainButtonIsActiveColor: false
            },
            buildingSideFieldIsEnabled: true
        };

        // console.log( "Stage4CheckInformation / benachrichtigungPer: " + this.state.benachrichtigungPer );

        //fix - since the constructor state setter has no callback
        setTimeout(() => {
            this.updateSubmitButtonState();
        },100)

    }

    /**
     * update previous tenant
     * @param event
     */
    updatePreviousTenantState = (event) => {
        const state = this.state;
        state.previousTenant[event.target.id] = event.target.value;
        this.setState(state,() => {this.updateSubmitButtonState()});
    };

    /**
     * update building data (floor, type, side)
     * @param event
     */
    updateBuildingState = (event) => {
        const state = this.state;
        state.building[event.target.id] = event.target.value;
        // console.log(state);
        this.setState(state,() => {this.updateSubmitButtonState()});
        document.activeElement.blur();

    };

    /**
     * update address (street, streetNumber, postCode, city)
     * @param event
     */
    updateAddressState = (event) => {
        const state = this.state;
        state.address[event.target.id] = event.target.value;
        this.setState(state,() => {this.updateSubmitButtonState()});
    };

    /**
     * update contact information (email, phoneNumber)
     * * replaces all special characters in phoneNumber field during entry
     * @param event
     */
    updateContactInformationState = (event) => {
        const state = this.state;
        state.contactInformation[event.target.id] = event.target.value;

        // #205 CARE-811 replace all special characters in phoneNumber field during entry (+49 will be substituted with 0)
        if( event.target.id == "phoneNumber" ) {
            this.state.contactInformation.phoneNumber = this.state.contactInformation.phoneNumber.replace(/\+49/,"0").replace(/[^\d]/g, "");
        }

        this.setState(state,() => {this.updateSubmitButtonState()});
        //this.updateSubmitButtonState();
    };

    /**
     * validator listener
     * @param result
     */
    validatorListener = (result) => {
        if(result){
            this.isValidForm = 1;
        }else{
            this.isValidForm = 0;
        }
        this.updateSubmitButtonState();
    };

    /**
     * update submit button state
     * - activate, when all required fields are filled in and form input is valid
     * - de-activate, when not all required fields are filled in or form input is not valid
     */
    updateSubmitButtonState = () => {
        if(
            (this.isValidForm !== 0)
            && (this.state.address.city && this.state.address.city.length > 0)
            && (this.state.address.postCode && this.state.address.postCode.length > 0)
            && (this.state.address.street && this.state.address.street.length > 0)
            && (this.state.address.streetNumber && this.state.address.streetNumber.length > 0)
            && (this.state.contactInformation.email && this.state.contactInformation.email.length > 0)
            && (this.state.contactInformation.phoneNumber && this.state.contactInformation.phoneNumber.length > 0)
            && (this.state.building.floor && this.state.building.floor.length > 0)
            && (this.state.building.type && this.state.building.type.length > 0)
            && (this.state.building.type === BUILDING_TYPES.EFH || this.state.building.side && this.state.building.side.length > 0)
        ){
            //console.log("ALL DATA GIVEN")
            this.setState({
                mainButtonSettings:{
                    mainButtonOnClick:() => {
                        this.props.saveCustomerDataCallback(
                            this.buildStateForParent()
                        )},
                    mainButtonIsActiveColor: true
                }
            })
        }else{
            //console.log("STILL DATA MISSING")
            this.setState({
                mainButtonSettings:{
                    mainButtonOnClick:() => {return true},
                    mainButtonIsActiveColor: false
                }
            })
        }


        if(this.state.building.type === "EFH"){
            this.setState({
                buildingSideFieldIsEnabled: false
            })
        }else{
            this.setState({
                buildingSideFieldIsEnabled: true
            })
        }
    };

    buildStateForParent = () => {
        return this.state;
    };

    /**
     * compile building floor options
     * @returns {*[]}
     */
    getFloorOptions = () => {
        const options = [
            <option key={"option-floor-none"} value="" />,
            <option key={"option-floor-basement"} value={"Keller"}>{i18n.t("basement")}</option>,
            <option key={"option-floor-parterre"} value={"Parterre"}>{i18n.t("Parterre")}</option>,
            <option key={"option-floor-subbasement"} value={"Souterrain"}>{i18n.t("souterrain")}</option>,
            <option key={"option-floor-groundfloor"} value={"Erdgeschoss"}>{i18n.t("ground_floor")}</option>,

        ];
        const max = 20;
        for(let i = 1;i <= max;i++){
            let normalizedFloor;

            if(i<9){
                normalizedFloor = "0"+i;
            }else if(i === max){
                normalizedFloor = max+"+";
            }else{
                normalizedFloor = i;
            }

            options.push(
                <option
                    value={i<9?"0"+i : i}
                    key={"option-floor-"+i}
                >
                    {i18n.t("level_x", {count: i})}
                </option>
            )
        }
        return options;
    };

    handleSubmit = () => {
        return true
    };

    /**
     * render
     * @returns {*}
     */
    render() {
        let floorOptions = this.getFloorOptions();

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        const bottomBarContent = <BottomBar
            showFullWidth={true}
            mainButtonOnClick={this.state.mainButtonSettings.mainButtonOnClick}
            mainButtonIsActiveColor={this.state.mainButtonSettings.mainButtonIsActiveColor}
            backButtonOnClick={() => {
                this.props.previousStep(this.buildStateForParent())
            }}
            mainButtonTextResource={"submit"}
            additionalText={"weekday_date"}
            weekday={
                getWeekdayFromDate(this.props.date)
            }
            date={
                formatDateForBottomBar(this.props.date)
            }
        />;

        const formContent = <div>
            <SubPageTopBar
                progress={3}
                onClickClose={this.props.onClickClose}
            />
            <SpacerRow/>
            <Row>
                <Col xs={12}>
                    <Header textResource={"check_your_information_title"} />
                </Col>
            </Row>
            <SpacerRow/>
            <Row>
                <Col xs={12}>
                    <p>Mit * gekennzeichnete Pflichtfelder bitte ausfüllen.</p>
                </Col>
            </Row>
            <SpacerRow/>
            <Row>
                <Col xs={12}>
                    <Subtitle textResource={"previous_tenant_name"} />
                </Col>
                <Col xs={6} className={"margin-16"}>
                    <TextField
                        className={"width-100"}
                        id={"firstName"}
                        type={"text"}
                        inputProps={{
                            maxLength: '100'
                        }}
                        label={i18n.t("first_name")}
                        value={this.state.previousTenant.firstName}
                        onChange={this.updatePreviousTenantState}

                    />
                </Col>
                <Col xs={6} className={"margin-16"}>
                    <TextField
                        className={"width-100"}
                        id={"lastName"}
                        type={"text"}
                        inputProps={{
                            maxLength: '1000'
                        }}
                        label={i18n.t("last_name")}
                        value={this.state.previousTenant.lastName}
                        onChange={this.updatePreviousTenantState}
                    />
                </Col>
            </Row>
            <SpacerRow/>
            <Row>
                <Col xs={12}>
                    <Subtitle textResource={"address_of_line"}/>
                </Col>
                <Col xs={8} className={"margin-16"}>
                    <TextField
                        className={"width-100"}
                        id={"street"}
                        type={"text"}
                        inputProps={{
                            maxLength: '1000'
                        }}
                        label={i18n.t("street")}
                        value={this.state.address.street}
                        onChange={this.updateAddressState}
                    />
                </Col>
                <Col xs={4} className={"margin-16"}>
                    <TextField
                        className={"width-100"}
                        id={"streetNumber"}
                        type={"text"}
                        inputProps={{
                            maxLength: '1000'
                        }}
                        label={i18n.t("street_number")}
                        value={this.state.address.streetNumber}
                        onChange={this.updateAddressState}
                    />
                </Col>

                <Col xs={4} className={"margin-16"}>
                    <TextField
                        className={"width-100"}
                        id={"postCode"}
                        type={"number"}
                        inputProps={{
                            maxLength: '1000'
                        }}
                        label={i18n.t("post_code")}
                        value={this.state.address.postCode}
                        onChange={this.updateAddressState}
                    />
                </Col>
                <Col xs={8} className={"margin-16"}>
                    <TextField
                        className={"width-100"}
                        id={"city"}
                        type={"text"}
                        inputProps={{
                            maxLength: '1000'
                        }}
                        label={i18n.t("city")}
                        value={this.state.address.city}
                        onChange={this.updateAddressState}
                    />
                </Col>
            </Row>
            <SpacerRow/>
            <Row>
                <Col xs={12}>
                    <Subtitle textResource={"contact_information"}/>
                </Col>
                <Col xs={12} className={"margin-16"}>
                    <TextValidator
                        className={"width-100"}
                        id={"phoneNumber"}
                        name={"phoneNumber"}
                        type={"text"}
                        inputProps={{
                            maxLength: '1000'
                        }}
                        label={i18n.t("contact_number")}
                        value={ this.state.contactInformation.phoneNumber ? this.state.contactInformation.phoneNumber.replace(/\+49/,"0").replace(/[^\d]/g, "") : "" }
                        onChange={this.updateContactInformationState}
                        validators={['matchRegexp:^(0049|0)[1-9][0-9]{4,}$']}
                        errorMessages={[i18n.t("invalid_phone_number")]}
                        validatorListener={this.validatorListener}
                        withRequiredValidator={true}
                    />
                </Col>
                <Col xs={12} className={"margin-16"}>
                    <TextValidator
                        className={"width-100"}
                        id={"email"}
                        name={"email"}
                        type={"email"}
                        inputProps={{
                            maxLength: '1000'
                        }}
                        label={i18n.t("contact_email")}
                        value={this.state.contactInformation.email}
                        onChange={this.updateContactInformationState}
                        validators={['matchRegexp:^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$']}
                        errorMessages={[i18n.t("invalid_email")]}
                        validatorListener={this.validatorListener}
                        withRequiredValidator={true}
                    />
                </Col>
            </Row>
            <SpacerRow/>
            <Row>
                <Col xs={12}>
                    <Subtitle textResource={"building_details"}/>
                </Col>
                <Col xs={12} className={"margin-16"}>
                    <FormControl className={"width-100"}>
                        <InputLabel htmlFor="building">{i18n.t("building")}</InputLabel>
                        <Select
                            native
                            inputProps={{
                                id: "type"
                            }}
                            onChange={this.updateBuildingState}
                            value={this.state.building.type}
                        >
                            <option value="" />
                            <option value={BUILDING_TYPES.MFH}>{i18n.t("apartment_building")}</option>
                            <option value={BUILDING_TYPES.EFH}>{i18n.t("detached_house")}</option>
                        </Select>
                    </FormControl>
                </Col>

                <Col xs={7} className={"margin-16"}>
                    <FormControl className={"width-100"}>
                        <InputLabel htmlFor="floor">{i18n.t("floor")}</InputLabel>
                        <Select
                            native
                            inputProps={{
                                id: "floor"
                            }}
                            onChange={this.updateBuildingState}
                            value={this.state.building.floor}
                        >
                            {floorOptions}
                        </Select>
                    </FormControl>
                </Col>

                <Col xs={5} className={"margin-16"}>
                    <FormControl className={"width-100"} disabled={!this.state.buildingSideFieldIsEnabled}>
                        <InputLabel htmlFor="side">{i18n.t("side")}</InputLabel>
                        <Select
                            native
                            inputProps={{
                                id: "side"
                            }}
                            onChange={this.updateBuildingState}
                            value={this.state.building.side}
                        >
                            <option value="" />
                            <option value={"links"}>{i18n.t("left")}</option>
                            <option value={"mitte"}>{i18n.t("middle")}</option>
                            <option value={"rechts"}>{i18n.t("right")}</option>
                        </Select>
                    </FormControl>

                    <TextField
                        id={"benachrichtigungPer"}
                        type={"hidden"}
                        value={this.state.benachrichtigungPer}
                    />

                </Col>
            </Row>

            <Row>
                <Col xs={7} className={"margin-16"}>
                    <FormControl className={"width-100"}>
                        <InputLabel htmlFor="radio">{"RadioTest"}</InputLabel>
                            <Radio
                                id="radio"
                                name="test1"
                                value="test1"
                            >
                            </Radio>
                    </FormControl>
                </Col>
            </Row>

        </div>;

        const validationFormContent = <ValidatorForm
            ref="validator_form"
            onSubmit={this.handleSubmit}
            onError={errors => console.log(errors)}
        >
            {formContent}
        </ValidatorForm>;


        return <Container fluid={true} style={{height:"200%",backgroundColor:"white"}}>
            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                {validationFormContent}
                <span className={"fixed-to-bottom fixed-to-bottom-nomargin"}>
                    {bottomBarContent}
                </span>
            </MobileView>

            <BrowserView>
                <Container>
                    <Row>
                    {footerLnk}
                    </Row>
                    <Row>
                        <Col sm={{ size: 8, offset: 2 }} md={{ size: 6, offset: 3 }} lg={{ size: 4, offset: 4 }}>
                            {validationFormContent}
                            {bottomBarContent}
                        </Col>
                    </Row>
                </Container>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage4CheckInformation);